import { render } from "./articles.vue?vue&type=template&id=8a27cbc2&scoped=true"
import script from "./articles.vue?vue&type=script&lang=js"
export * from "./articles.vue?vue&type=script&lang=js"

import "./articles.vue?vue&type=style&index=0&id=8a27cbc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a27cbc2"]])

export default __exports__